import { render, staticRenderFns } from "./ButtonGroup.vue?vue&type=template&id=4633b7e0"
import script from "./ButtonGroup.vue?vue&type=script&lang=js"
export * from "./ButtonGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports